import { EmptyData } from 'components/EmptyData';
import { classNames, React } from 'libs/react';
import './ActivityEmpty.scss';
/**
 * @component ActivityEmpty
 * @since 1.0.0
 * EmptyData sized for side panels and tabs.
 */
export function ActivityEmpty(props) {
    return (React.createElement(EmptyData, { className: classNames('activity-empty', props.className), picto: props.picto, title: props.title, description: props.description }));
}
